// extracted by mini-css-extract-plugin
export default {"header":"HashrateChart_header__5-jKb","placeholder":"HashrateChart_placeholder__LxobO","note":"HashrateChart_note__hsz+r"};